<div class="d-flex justify-content-center align-items-center">
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">
        <div class="card mt-2">
          <div class="card-body p-4">
            <form class="mb-3 mt-md-4" [formGroup]="form" (ngSubmit)="changePassword()">
              <h4 i18n>Set new password</h4>
              <p i18n>The password should be at least 12 characters long, contain at least one uppercase letter, one
                lowercase letter, one number and one special character.</p>
              <div class="mb-3">
                <label for="current_password" class="form-label" i18n>Current password</label>
                <div class="input-group">
                  <input [type]="showCurrentPassword ? 'text' : 'password'" class="form-control" id="current_password" autocomplete="current-password" formControlName="current_password">
                  <button type="button" class="btn btn-primary" style="width: 3.5rem;" (click)="showCurrentPassword = !showCurrentPassword">
                    <fa-icon [icon]="showCurrentPassword ? fa.faEyeSlash : fa.faEye" style="color: #fff; position: relative; top: -1px;"></fa-icon>
                  </button>
                </div>
              </div>
              <div class="mb-3">
                <label for="new_password" class="form-label" i18n>New password</label>
                <div class="input-group">
                  <input [type]="showNewPassword ? 'text' : 'password'" class="form-control" id="new_password" autocomplete="new-password" formControlName="new_password">
                  <button type="button" class="btn btn-primary" style="width: 3.5rem;" (click)="showNewPassword = !showNewPassword">
                    <fa-icon [icon]="showNewPassword ? fa.faEyeSlash : fa.faEye" style="color: #fff; position: relative; top: -1px;"></fa-icon>
                  </button>
                </div>
                <div *ngIf="form.get('new_password')?.invalid && form.get('new_password')?.touched" class="text-danger small" i18n>
                  Password must be at least 12 characters long and contain uppercase, lowercase, number and special character
                </div>
              </div>
              <div class="mb-3">
                <label for="confirm_password" class="form-label" i18n>Confirm new password</label>
                <div class="input-group">
                  <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control" id="confirm_password" autocomplete="new-password" formControlName="confirm_password">
                  <button type="button" class="btn btn-primary" style="width: 3.5rem;" (click)="showConfirmPassword = !showConfirmPassword">
                    <fa-icon [icon]="showConfirmPassword ? fa.faEyeSlash : fa.faEye" style="color: #fff; position: relative; top: -1px;"></fa-icon>
                  </button>
                </div>
                <div *ngIf="form.get('confirm_password')?.invalid && form.get('confirm_password')?.touched" class="text-danger small" i18n>
                  Passwords do not match
                </div>
              </div>
              <div class="d-grid">
                <button type="button" class="btn btn-primary" [disabled]="!this.form.valid || this.form.controls.new_password.value != this.form.controls.confirm_password.value" (click)="changePassword()" i18n>Change password</button>
                <a routerLink="/settings" class="btn btn-secondary mt-3" i18n>Back to settings</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>